const columns = [
	{
		id: 'Email',
		name: 'Email',
		cell: row => row.Email,
		width: '300px'
	}, {
		id: 'display_name',
		name: 'Display Name',
		cell: row => row.FirstName + " " + row.LastName,
		width: '200px'
	}, {
		id: 'action',
		name: '',
		width: '200px'
	}
];

export default columns;